import { configureAccountLinks } from '@family-space/account-links';
import { createPinia } from 'pinia';
import { createApp } from 'vue';

import { useUserStore } from '@/entities/user';
import {
  createSeoHead,
  initHotkeys,
  ProjectSettings,
  resolveHomeReturnTo,
  themeController,
} from '@/shared/lib';

import { initApiInterceptors } from './config/api-interceptors';
import { i18n } from './config/i18n';
import { initObservability } from './config/observability';
import { initPushNotifications } from './config/push-notifications';
import { initPwa } from './config/pwa';
import { router } from './config/router';
import { initUiKit } from './config/ui-kit';
import { App } from './layout';

configureAccountLinks({
  accountUrl: ProjectSettings.account.url,
  resolveReturnTo: resolveHomeReturnTo,
});

const app = createApp(App);
const head = createSeoHead();

initApiInterceptors();
themeController.init();
initUiKit(app);
app.use(i18n);
app.use(createPinia());
app.use(router);
app.use(head);

const userStore = useUserStore();

if (ProjectSettings.pwa.enabled) {
  initPwa();
}
if (ProjectSettings.pushNotifications.enabled) {
  initPushNotifications(() => (userStore.isFetched ? (userStore.user?.id ?? null) : undefined));
}

initObservability(app, router);

initHotkeys();

app.mount('#app');
